// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b1671e9","239":"cafd29b4","731":"e1f3ada0","732":"ad2c4c28"}[chunkId] + ".chunk.js";
};